export default __webpack_public_path__ + "static/media/WES.24d2afc3.png";